
import React, { useState, useEffect, useMemo } from "react";
import {Dialog as FluentDialog,Text,Button,Input,Form,FormInput,Loader,EditIcon,TrashCanIcon,Checkbox,Datepicker,Card,CardBody,CardHeader,
  FormDropdown,Dropdown,Label,TextArea} from "@fluentui/react-northstar";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import {
  AddIcon,
  SearchIcon,
  CloseIcon,
} from "@fluentui/react-icons-northstar";
import { WindowContext } from "../../shared/contexts/Context";
import { process } from "@progress/kendo-data-query";
import { OPERATIONSTATUS } from "../../shared/appcomponents/enums";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import debounce from "lodash.debounce";
import { RenderTooltipCell } from "../../shared/appcomponents/TooltipWithCopy";
import SettingsService from "../../services/settingsservice";
import { CellDateTime } from "../../../components/shared/appcomponents/custom-grid-cells";
import {
  NativeTimePicker,
  TeamsDatePicker,
  TeamsTimePicker,
  TimeList,
} from "../../../components/shared/appcomponents/custom-datetime-inputs";

const SettingsQueryAnalyzer = (props) => {
  const [alerts, setAlerts] = useState([]);
  const [alertData, setAlertData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isHeadingValid, setIsHeadingValid] = useState(true);
  const [isQueryValid, setIsQueryValid] = useState(true);
  const [isEmailIdsValid, setIsEmailIdsValid] = useState(true);
  const [isInstanceValid, setisInstanceValid] = useState(true);
  const [openDeleteConfirmationDialog, setDeleteConfirmationDialog] =
    useState(false);
  const [deleteAlertObj, setDeleteAlertObj] = useState(null);   
  const [selectedAlertType, setselectedAlertType] = React.useState({
    header: "Select",
    value: "0",
    key: 1,
  });
  const [selectedInstance, setselectedInstance] = React.useState(null);
  const [selectedUser, setselectedUser] = React.useState(null);
  const [instances, setinstances] = React.useState(null);
  const [users, setusers] = React.useState(null);
  const [dataState, setDataState] = useState({
    sort: [{ field: "Id", dir: "asc" }],
    take: 10,
    skip: 0,
    filter: {
      logic: "or",
      filters: [],
    },
  });
  const [isSaving, setIsSaving] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [allKeys, setAllKeys] = useState([]); // Moved allKeys to state
  const [newAlertData, setNewAlertData] = useState({
    TaskTypeId: "",
    Heading: "",
    InstanceId: "",
    Query: "",
    EmailIds: "",
    NextRunTime: new Date(),
    IsActive: false,
  });
  const [queryText, setQueryText] = useState('');
  const [qrLoading, setQrLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const [queryMessage, setQueryMessage] = useState('');
  useEffect(() => {
    props.acquireToken(authSuccessCallback);
    
  }, []);

  // Function to extract keys from data
  const extractKeysFromData = (data) => {
    const keys = new Set();
    data.forEach(item => {
      Object.keys(item).forEach(key => keys.add(key));
    });
    return Array.from(keys);
  };

  const authSuccessCallback = (token) => { debugger;
    if (token) {
      {/*let queryAnalyzer = {
        instanceId : 38,  
        sqlQuery: "SELECT top 4  tenantid,tenant_name,customer_name,emailid,Date_created FROM dbo.tenants where isactive=1"          
        };
      SettingsService.GetDataQueryAnalyzer(token,queryAnalyzer).then((response) => {
        if (response && response.status === 200) {
          setAlerts(response.data);
          setIsLoaded(true);
          setDataState({ ...dataState, data: response.data });
          
          // Extract keys and set to state
          const extractedKeys = extractKeysFromData(response.data);
          setAllKeys(extractedKeys);

          SettingsService.GetInstanceDataQueryAnalyzer(token).then(
            (response) => {
              if (response && response.status == 200) {
                response = response.data;                
                setinstances(response);                
              }
            }
          );
        } else {
          props.viewStatus.InformChildPageStatus(response.status || 500);
          setIsLoaded(true);
        }
      });*/}

      SettingsService.GetInstanceDataQueryAnalyzer(token).then(
            (response) => {
              if (response && response.status == 200) {
                response = response.data;                
                setinstances(response);   
                setIsLoaded(true);             
              }
            }
          );

    }
  };

  const filterGridData = (value) => {
    let filter = {
      logic: "or",
      filters: [
        { field: "Id", operator: "contains", value: value },
        { field: "Heading", operator: "contains", value: value },
        { field: "Query", operator: "contains", value: value },
        { field: "EmailIds", operator: "contains", value: value },
      ],
    };
    setDataState({ ...dataState, filter: filter });
  };

  const handleAddEditClickOpen = (dataItem, isEdit) => {
    setIsHeadingValid(true);
    setIsQueryValid(true);
    setIsEmailIdsValid(true);
    setVisible(true);
    setisInstanceValid(true);
    setIsSaving(false);

    if (isEdit === true) {
      setAlertData(dataItem);      

      if (instances && instances.length > 0) {
        let ins = instances.filter((obj) => {
          return obj.InstanceId === dataItem.InstanceId;
        });

        if (ins && ins.length > 0) {
          setselectedInstance({
            header: ins[0].InstanceName,
            value: ins[0].InstanceName,
            key: ins[0].InstanceId,
          });
        }
      }

      if (
        users &&
        users.length > 0 &&
        dataItem.EmailIds &&
        dataItem.EmailIds.length > 0
      ) {
        let arr = dataItem.EmailIds.split(",");

        if (arr && arr.length > 0) {
          let arr_users = [null];

          for (let i = 0; i < arr.length; i++) {
            let sel = users.filter((obj) => {
              if (
                obj &&
                obj.value &&
                obj.value.length > 0 &&
                arr[i] &&
                arr[i].length > 0
              ) {
                return obj.value.toLowerCase() === arr[i].toLowerCase();
              }
            });

            if (sel && sel.length > 0) {
              arr_users.push({
                header: sel[0].header,
                value: arr[i],
                key: arr[i],
              });
            }
          }
          setselectedUser(arr_users);
        }
      }  
      setEditMode(true);
    } else {
      setAlertData({
        Id: 0,
        TaskTypeId: "",
        Heading: "",
        InstanceId: "",
        Query: "",
        EmailIds: "",
        NextRunTime: new Date(),
        IsActive: false,
        IsTimeSet: false,
        StartTime: "00:00",
        EndTime: "00:00",
      });
      setselectedInstance(null);
      setEditMode(false);
      setAlertData({
        ...alertData,
        IsActive: true,
        StartTime: "00:00",
        EndTime: "00:00",
      });
      setselectedAlertType({ header: "Hourly", value: "Hourly", key: 1 });
      let usersSelected = [null];
      setselectedUser(null);
    }
  };

  const handleAddEditClickClose = () => {
    setVisible(false);
    setAlertData(null);
    setEditMode(false);
    setIsHeadingValid(true);
    setIsQueryValid(true);
    setIsEmailIdsValid(true);
  };

  const handleDeleteClickOpen = (dataItem) => {
    setDeleteAlertObj(dataItem);
    setDeleteConfirmationDialog(true);
  };

  const handleDeleteClose = () => {
    setDeleteConfirmationDialog(false);
    setDeleteAlertObj(null);
  };

  const handleSave = () => {
    

      //alert(queryText);

      //alert(selectedInstance.key);
      setQrLoading(true);
      props.acquireToken((token) => {
    if (token) {
      let params = {
        instanceId : selectedInstance.key,  
        sqlQuery: queryText,          
        };
      SettingsService.GetDataQueryAnalyzer(token,params).then((response) => { 
        if (response && response.status === 200) {
          if(response.data.isSuccess)
          {
          setAlerts(response.data.dtRsult);
          setIsLoaded(true);
          setDataState({ ...dataState, data: response.data.dtRsult });
          
          // Extract keys and set to state
          const extractedKeys = extractKeysFromData(response.data.dtRsult);
          setAllKeys(extractedKeys);
          setIsSuccess(true);
          }
          else
          {
            //alert(response.data.message);
            setIsSuccess(false);
            setQueryMessage(response.data.queryMessage);
          }
          setQrLoading(false);
          SettingsService.GetInstanceDataQueryAnalyzer(token).then(
            (response) => {
              if (response && response.status == 200) {
                response = response.data;                
                setinstances(response);                
              }
            }
          );
        } else {
          props.viewStatus.InformChildPageStatus(response.status || 500);
          setIsLoaded(true);
        }
      });
    }
  });

      

    setIsSaving(true);
    props.acquireToken((token) => {
      // Save logic here
    });
  };

  const handleDelete = () => {
    const updatedAlerts = alerts.filter(
      (alert) => alert.Id !== deleteAlertObj.Id
    );
    setAlerts(updatedAlerts);

    props.acquireToken((token) => {
      SettingsService.DeleteCustomisedAlert(deleteAlertObj.Id, token)
        .then((response) => {
          if (response && response.status === 200) {
            setDataState({ ...dataState, data: updatedAlerts });
            handleDeleteClose();
            props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
          } else {
            setAlerts(alerts);
            props.viewStatus.DisplayOperationStatus(response.status || 500);
          }
        })
        .catch(() => {
          setAlerts(alerts);
        });
    });
  };

  const processedData = useMemo(
    () => process(alerts, dataState),
    [alerts, dataState]
  );

  const handleToggleChange = (dataItem) => {
    const updatedAlert = { ...dataItem, IsActive: !dataItem.IsActive };
    props.acquireToken((token) => {
      SettingsService.UpdateCustomisedAlert(updatedAlert, token).then(
        (response) => {
          if (response && response.status === 200) {
           // authSuccessCallback(token);
            props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
          } else {
            props.viewStatus.DisplayOperationStatus(response.status || 500);
          }
        }
      );
    });
  };

  const handleDateChange = (e, data) => {
    const localDate = new Date(data.value);
    setAlertData({ ...alertData, NextRunTime: localDate });
  };

  const handleAlertTypeChange = (_selectedType) => {
    setselectedAlertType(_selectedType);
  };

  const handleInstanceChange = (_selectedType) => {  
    setselectedInstance(_selectedType);
    if(_selectedType && _selectedType.value && _selectedType.value.key > 0){
      setisInstanceValid(true);
    }
    else{
      setisInstanceValid(false);
    }
  };

  const handleUserChange = (_selectedType) => {
    setselectedUser(_selectedType);
  };

  const handleStartTimeChange = (e, data) => {
    setAlertData({ ...alertData, StartTime: data.value });
  };

  const handleEndTimeChange = (e, data) => {
    setAlertData({ ...alertData, EndTime: data.value });
  };
  const handleChange = (event) => {
                setQueryText(event.target.value);
  };

  const handleSaveDebounced = debounce(handleSave, 300);

  return isLoaded ? (
    <WindowContext.Consumer>
      {(context) => (
        <div className="row h-100">
          <div className="col-md-12 h-100">
            <Card className="card-border bg-white h-100" fluid>
              <CardHeader className="mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="f-size-18">Query Analyzer</div>
                  {props.user?.Permissions?.some(
                    (p) =>
                      p == "Settings.ReadWrite" ||
                      p == "Settings.Configuration.ReadWrite"
                  )}
                  <div className="instancedrop">
                    <span>Select Instance</span>
                    <Dropdown
                      className="custom-alert-type"
                      label={{
                        content: `Alert Type Name`,
                      }}
                      items={instances?.map((obj) => {
                        return {
                          header: obj.InstanceName,
                          value: obj.InstanceName,
                          key: obj.InstanceId,
                        };
                      })}
                      placeholder="Select"
                      fluid
                      value={selectedInstance}
                      onChange={(e, selectedItem) => {
                        handleInstanceChange(selectedItem.value);
                      }}
                    />
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <div style={{ width: "100%" }}>
                  <div className="executequery">
                    <textarea
                      id=""
                      className="text-area"
                      placeholder="enter query"
                      width="100%"
                      height="200"
                      onChange={handleChange}
                    ></textarea>
                    {/* Buttons below textarea */}
                    <div className="textarea-actions mb-3 flex">
                    {!isSuccess ? <div style={{ textAlign: "left",color:"red" }}>{queryMessage}</div> : ""}
                     {qrLoading ? <Loader size="small"  />:""}                      
                      
                      <Button
                        primary
                        className="btn-run"
                        appearance="primary"
                        onClick={handleSaveDebounced}
                      >
                        Run
                      </Button>
                      <Button
                        className="btn-clear"
                        appearance="secondary"
                        onClick={() => console.log("Clear clicked")}
                      >
                        Clear
                      </Button>
                    </div>
                  </div>
                </div>
                <div
                  className="tbl-search float-right text-right mb-2"
                  style={{ display: "none" }}
                >
                  <Input
                    onChange={(e) => filterGridData(e.target.value)}
                    inverted
                    icon={<SearchIcon />}
                    placeholder="Search..."
                    className="border-gray"
                  />
                </div>
                <div className="grid-with-search" style={{ display: "block" }}>
                  <Grid
                    style={{
                      height: "100%"
                    }}
                    pageable={{
                      buttonCount: 3,
                    }}
                    sortable={true}
                    data={processedData.data}
                    total={processedData.total}
                    skip={dataState.skip}
                    take={dataState.take}
                    sort={dataState.sort}
                    onDataStateChange={(e) => {
                      setDataState(e.dataState);
                    }}
                  >
                    {allKeys.map(key => (
                      <Column 
                        key={key} 
                        field={key} 
                        title={key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())} 
                        width={key === "NextRunTime" ? "250px" : "200px"}
                        cell={key === "NextRunTime" ? CellDateTime : undefined}
                      />
                    ))}
                  </Grid>
                </div>
              </CardBody>
            </Card>
          </div>
          
          <FluentDialog
            cancelButton="Cancel"
            confirmButton="Confirm"
            onCancel={handleDeleteClose}
            onConfirm={handleDelete}
            open={openDeleteConfirmationDialog}
            backdrop
            header="Confirm"
            headerAction={{
              icon: <CloseIcon />,
              title: "Close",
              onClick: () => {
                setDeleteConfirmationDialog(false);
                setDeleteAlertObj(null);
              },
            }}
            content={`Are you sure you want to delete the customised alert "${deleteAlertObj?.Heading}"?`}
          />
        </div>
      )}
    </WindowContext.Consumer>
  ) : (
    <Loader />
  );
};

export default SettingsQueryAnalyzer;
